module.exports = __webpack_public_path__ + "static/media/play-board-2.8a1a9841.png";